import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { PublicClientApplication } from '@azure/msal-browser';
import { MSAL_INSTANCE } from '@azure/msal-angular';
import { msalConfig } from './app/core/config/msal.config';

async function main() {

  //Inicializar msalConfig
  const msalInstance = new PublicClientApplication(msalConfig);
  await msalInstance.initialize();

  const extendedAppConfig = {
    ...appConfig,
    providers: [
      { 
        provide: MSAL_INSTANCE, 
        useValue: msalInstance 
      },
      ...appConfig.providers
    ]
  };

  await bootstrapApplication(AppComponent, extendedAppConfig);
}

main().catch(err => console.error(err));